<template lang="html">

  <section class="intro-xs" :data-bkg="where">
      <div class="col-50 flex column nowrap justify-center align-center animated fadeInLeft">
        <div class="container-text">
          <h2 class="title title-52">{{$t('enlaces.textos.sala_prensa')}}</h2>
        </div>
      </div>
    </section>

</template>

<script lang="js">
  export default  {
    name: 'sala-prensa',
    props: [],
    mounted() {

    },
    data() {
      return {

      }
    },
    methods: {

    },
    computed: {
        where : function (){
          if(!!this.data){
            return this.$route.params.id;
          }
        }
    }
}
</script>

<style scoped >

  [data-bkg="productos"]{
        background: url(/static/img/blog/blog-productos.webp) no-repeat center right/50%;
  }

</style>



// WEBPACK FOOTER //
// src/components/view-parts/intros/sala-prensa.vue